import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { AuthService } from './auth.service';
import { PolicyService } from 'app/services/policy-service';

declare function desloadChat(): any;

@Injectable()
export class AuthRedirectorGuard implements CanActivate {

    private restrictedRoutes: string[] = [
        '/products',
        '/insurances',
        '/productService',
        '/receipts',
        '/modify/payment',
        '/modify/preferences',
        '/events/register',
        '/events/register/',
        '/contact',
        '/hire'
    ]

    private restrictedRoutesInsured: string[] = [
        '/modify/preferences'
    ]

    constructor(private router: Router, private authService: AuthService,
                private policyService: PolicyService) { }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

        if (!this.authService.isLogged()) {
            desloadChat();
            this.router.navigate(['/authentication']);
            return true;
        }

        if (state.url === '/') {
            this.router.navigate(['/main']);
            return true;
        }

        if (this.authService.getSelectedEntity() !== 'ONLYGAL') {
            this.validateRouteForReinsured(state.url);
            return true;
        }

        // La relación con las pólizas se resuelve contra el backend (una sola búsqueda
        // cacheada por sesión y entidad), no contra el token: sus productsIds no distinguen
        // entre tomador y asegurado. Devolver la promesa retrasa la navegación lo que tarde
        // esa primera llamada; el resto de rutas ya la encuentran resuelta.
        return this.policyService.isTaker()
            .then(isTaker => {
                if (!isTaker) {
                    this.validateRouteForInsured(state.url);
                }
                return true;
            });
    }

    validateRouteForReinsured(navigatedUrl) {
        if (navigatedUrl) {
            this.restrictedRoutes.forEach(r => {
                if (navigatedUrl.lastIndexOf(r, 0) == 0) {
                    this.router.navigate(['/main']);
                }
            })
        }
    }

    validateRouteForInsured(navigatedUrl) {
        if (navigatedUrl) {
            this.restrictedRoutesInsured.forEach(r => {
                if (navigatedUrl.lastIndexOf(r, 0) == 0) {
                    this.router.navigate(['/main']);
                }
            })
        }
    }
}
